import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { URL_QUERY_PARAMS } from 'shared/constants/queryParams'

export const useUrlFilterParam = () => {
  const history = useHistory()

  return useCallback(
    (param: string, value: string) => {
      const params = new URLSearchParams(history.location.search)
      const normalizedValue = value.trim()
      const currentValue = params.get(param) || ''

      if (currentValue === normalizedValue) return

      if (normalizedValue) {
        params.set(param, normalizedValue)
      } else {
        params.delete(param)
      }

      params.delete(URL_QUERY_PARAMS.PAGE)
      params.delete(URL_QUERY_PARAMS.START_CURSOR)
      params.delete(URL_QUERY_PARAMS.END_CURSOR)

      history.replace({
        pathname: history.location.pathname,
        search: params.toString() ? `?${params.toString()}` : '',
      })
    },
    [history]
  )
}
